import { BlueprintLayout } from '@features/blueprint/BlueprintLayout';

export default function BlueprintPage() {
  return <BlueprintLayout />;
}
